export const GET_DEBUG_URL = 'GET_DEBUG_URL'
export const PREPARE_REDIRECT_ECOMDASH = 'PREPARE_REDIRECT_ECOMDASH'
